import React, { Component } from 'react';
import Typography from 'material-ui/Typography';

import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import moment from 'moment';

import VehicleSelect from './Select/Vehicle';

import { withRouter } from 'react-router-dom';

class TimelineFilter extends Component {

    constructor() {
        super();

        this.state = {
            filter_type: true
        };
    }

    changeFilterType = () => {
        this.setState({filter_type: !this.state.filter_type});
    };

    render() {

        const params = new URLSearchParams(this.props.location.search);
        const vehicle_id = params.get('vehicle_id');

        const filter = e => {
            e.preventDefault();

            this.props.onSubmit({
                date: document.getElementById('date') && document.getElementById('date').value,
                vehicle_id: document.getElementById('vehicle_id') && document.getElementById('vehicle_id').value,
                document_id: document.getElementById('document_id') && document.getElementById('document_id').value
            });
        };

        console.log('this.state.filter_type', this.state.filter_type);

        return (
            <form onSubmit={filter}>
                <p><Typography type="caption" gutterBottom>FILTROS</Typography></p>

                <div>
                    <div className={'form-item'}>
                        <label>Pesquisar por:</label>
                        <select id="filter_type" onChange={this.changeFilterType}>
                            <option value="0">Veículo e Data</option>
                            <option value="1">Documento de Entrega</option>
                        </select>
                    </div>
                </div>

                {
                    this.state.filter_type && (
                        <div>
                            <div>
                                <TextField
                                    id="date"
                                    label="Dia"
                                    type="date"
                                    required
                                    defaultValue={moment().format('YYYY-MM-DD')}
                                    InputLabelProps={{shrink: true}}
                                    margin="normal"
                                    fullWidth
                                />
                            </div>

                            <div style={{marginTop: '16px'}}>
                                <small className="label" style={{color: '#888', fontSize: '0.8em'}}>Veículo *</small>
                                <VehicleSelect defaultValue={vehicle_id}/>
                            </div>
                        </div>
                    )
                }

                {
                    !this.state.filter_type && (
                        <div>
                            <TextField
                                id="document_id"
                                label="Número Documento"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                    )
                }

                <Button type="submit" raised color="primary" style={{width: '100%', marginTop: '16px'}}>
                    Consultar
                </Button>
            </form>
        );
    }
}

export default withRouter(TimelineFilter);



// WEBPACK FOOTER //
// ./src/components/TimelineFilter.js